var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "label/24/ic_notes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "label/24/ic_notes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.77325,7.577 C22.07625,10.525 22.07625,13.474 21.77325,16.423 C21.48425,19.241 19.24225,21.483 16.42325,21.773 C14.94925,21.924 13.47525,22 12.00025,22 C10.52625,22 9.05125,21.924 7.57725,21.773 C4.75825,21.483 2.51625,19.241 2.22725,16.423 C1.92425,13.474 1.92425,10.525 2.22725,7.577 C2.51625,4.759 4.75825,2.516 7.57725,2.226 C9.05125,2.075 10.52625,2 12.00025,2 C13.47525,2 14.94925,2.075 16.42325,2.226 C19.24225,2.516 21.48425,4.759 21.77325,7.577 Z M8.00025,8.9998 L16.00025,8.9998 C16.5525347,8.9998 17.00025,8.55208475 17.00025,7.9998 C17.00025,7.44751525 16.5525347,6.9998 16.00025,6.9998 L8.00025,6.9998 C7.44796525,6.9998 7.00025,7.44751525 7.00025,7.9998 C7.00025,8.55208475 7.44796525,8.9998 8.00025,8.9998 Z M8.00025,12.9998 L16.00025,12.9998 C16.5525347,12.9998 17.00025,12.5520847 17.00025,11.9998 C17.00025,11.4475153 16.5525347,10.9998 16.00025,10.9998 L8.00025,10.9998 C7.44796525,10.9998 7.00025,11.4475153 7.00025,11.9998 C7.00025,12.5520847 7.44796525,12.9998 8.00025,12.9998 Z M8.00025,16.9998 L12.00025,16.9998 C12.5525347,16.9998 13.00025,16.5520847 13.00025,15.9998 C13.00025,15.4475153 12.5525347,14.9998 12.00025,14.9998 L8.00025,14.9998 C7.44796525,14.9998 7.00025,15.4475153 7.00025,15.9998 C7.00025,16.5520847 7.44796525,16.9998 8.00025,16.9998 Z",
    fill: "#494A4A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotes);
export default __webpack_public_path__ + "static/media/ic_notes.3eee0367b47b681851eb6243e9c086fb.svg";
export { ForwardRef as ReactComponent };